var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"dream-description"},[_c('p',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(" "+_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }